import { ThemeUICSSObject } from 'theme-ui';

export const headerStyles: ThemeUICSSObject = {
  justifyContent: 'space-between',
  alignItems: 'center',
};
